import styled from 'styled-components';
import TodoList from '../components/TodoList';

export const DashboardContainer = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: #1D2125;
  min-height: calc(100vh - 41px);
  position: relative;
  margin-top: 41px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ToggleLinks = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 24px;
`;

export const LinkButton = styled.a`
    cursor: pointer;
    color: #B6C2CF;
    text-decoration: none;
    padding: 0 4px;

    &:hover {
        color: #fff;
    }
`;

// Removed SearchInput and FilterDropdown styled components

export const ToggleLinksContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 4px;
    z-index: 99;

    @media (max-width: 768px) {
        padding: 0;
    }
`;

export const MainWrapper = styled.div`
  display: flex;
`;

export const MainContent = styled.div`
  padding: 24px;
  // padding-right: 0;
  padding-top: 0;
  flex: 1;
  min-width: 0;
  display: ${props => props.isOpen ? 'block' : 'none'};

  @media (max-width: 768px) {
    padding: 0;
  }
`;


export const ProjectsHeader = styled.div`
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    @media (max-width: 768px) {
        margin-bottom: 16px;
    }
`;

export const HeaderButtons = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap; // Allow items to wrap

    @media (max-width: 768px) {
        gap: 8px;
        // Add some vertical gap when items wrap
        & > * { // Target all direct children
            margin-bottom: 8px;
        }
        // Optional: Reset margin for the last item in a row if needed,
        // but simple margin-bottom on all wrapped items is usually fine.
    }

    @media (max-width: 480px) {
        gap: 6px;
        & > * {
            margin-bottom: 6px;
        }
    }
`;

export const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  align-items: start;
`;

export const AddProjectButton = styled.button`
    background: #579DFF;
    color: rgba(255, 255, 255, 0.8);
    border: none;
    border-radius: 8px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
        background: #398BFF;
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }

    svg {
        width: 16px;
        height: 16px;
    }

    @media (max-width: 768px) {
        padding: 8px 12px;
        font-size: 13px;
        
        svg {
            width: 14px;
            height: 14px;
        }
    }

    @media (max-width: 480px) {
        padding: 6px 10px;
        font-size: 12px;
        
        svg {
            width: 12px;
            height: 12px;
        }
    }
`;

export const MenuButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  color: #B6C2CF;
  padding: 8px;
  cursor: pointer;
  border-radius: 3px;
  
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const SectionTitle = styled.h2`
  color: #B6C2CF;
  font-size: 20px;
  font-weight: 600;
  margin: 0;

  svg {
    width: 18px;
    height: 18px;
    fill: #f2d600;
    margin-right: 4px;
  }

`;

export const ProjectSection = styled.div`
  margin-bottom: 32px;

  ${SectionTitle} {
    margin-bottom: 16px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: #B6C2CF;
  font-size: 16px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  color: #B6C2CF;
  background: #282E33;
  border-radius: 8px;
  margin: 20px 0;
`;

export const GlobalTodoList = styled(TodoList)`
  margin: 0;
  padding: 12px;
  height: 100%;
  // max-height: calc(90vh - 70px);

  /* Webkit browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
  }

  &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 4px;
      
      &:hover {
          background: rgba(255, 255, 255, 0.3);
      }
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
`;

export const SidebarHeader = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 8px 8px 24px;
    height: 41px;
    border-bottom: 1px solid #3B444C;
  }
`;

export const SidebarTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  color: #B6C2CF;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #B6C2CF;
  cursor: pointer;
  border-radius: 3px;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ClockContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100% - 71px);
    width: 100%;
    position: absolute;
    top: 71px;
    left: 0;
    color: white;

    .settings-button {
        position: absolute;
        top: 50%;
        left: 100%;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        color: white;
        cursor: pointer;
        opacity: 0;
        transition: opacity 0.3s ease;
        margin-left: 10px;
    }

    .clock-wrapper:hover .settings-button {
        opacity: 1;
    }
`;

export const FocusInputContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 10vh;
`;

export const ResizerHandle = styled.div`
    width: 8px;
    cursor: ew-resize;
    position: absolute;
    top: 0;
    bottom: 0;
    right: -4px; /* Half of its width to be on the outside */
    z-index: 1001;
    background: transparent; /* Make it invisible by default */
    &:hover {
        background: rgba(255, 255, 255, 0.1); /* Show handle on hover */
    }
`;

export const FocusText = styled.div`
    font-size: 2rem;
    margin-bottom: 1rem;
    text-align: center;
`;

export const FocusInput = styled.input`
    padding: 0.3rem;
    border: none;
    border-bottom: 1px solid white;
    color: white;
    // width: 30rem; /* Uncommented and set a fixed width */
    text-align: center;
    font-size: 1.5rem;
    background: none;
    width: 100%; /* Added */
    max-width: 30rem; /* Added, changed from commented width: 30rem; */

    &::placeholder { /* Styles for the placeholder text */
        color: white;
        opacity: 0.7; /* Adjust opacity as needed */
    }

    &:focus {
        outline: none;
    }
`;

export const FocusList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin-bottom: 1rem; /* Added margin to separate from input */
    max-height: 200px;
    max-width: 90vw;
    overflow-y: auto;
    overflow-x: hidden;

    /* Webkit browsers (Chrome, Safari) */
    &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;

        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }

    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
`;

export const FocusListItem = styled.li`
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
`;

export const FocusCheckbox = styled.input`
    margin-right: 0.5rem;
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
    border-radius: 2rem;
`;

export const FullscreenButton = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 100;
  color: #B6C2CF;

  &:hover {
    color: #fff;
  }
`;

export const ClockSettingsContainer = styled.div`
    color: #B6C2CF;
    padding: 20px;
    border-radius: 8px;

    h3, h4 {
        color: #fff;
        margin-top: 0;
    }

    label {
        display: block;
        margin-bottom: 10px;
    }
`;

export const SettingsSlider = styled.input`
    width: 100%;
`;
